
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";

const BuyerLandingHero = () => {
  const scrollToHowItWorks = () => {
    const howItWorksSection = document.getElementById('how-it-works');
    if (howItWorksSection) {
      howItWorksSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto text-center max-w-4xl">
        <Badge className="mb-6 bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] animate-fade-in-stable">
          Free for Investors
        </Badge>
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight animate-fade-in-stable" style={{ animationDelay: '0.1s', animationFillMode: 'both' }}>
          Find Your Next 
          <span className="text-[#ffd700] gradient-text"> Investment Property</span>
        </h1>
        <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto animate-fade-in-stable" style={{ animationDelay: '0.2s', animationFillMode: 'both' }}>
          Discover high-quality investment opportunities, connect directly with wholesalers, 
          and build your portfolio faster with GoDyspo's investor marketplace.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-stable" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
          <Link to="/buyer/register">
            <Button size="lg" className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] px-8 hover-lift group">
              Create Free Account
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <Button 
            size="lg" 
            variant="outline" 
            className="border-[#ffd700] text-[#ffd700] hover:bg-[#ffd700] hover:text-[#080c14] hover-lift"
            onClick={scrollToHowItWorks}
          >
            See How It Works
          </Button>
        </div>
        {/* Mobile App Badge */}
        <div className="flex flex-col items-center gap-2 mt-4 animate-fade-in-stable" style={{ animationDelay: '0.4s', animationFillMode: 'both' }}>
          <span className="text-sm text-gray-400">Also available on mobile</span>
          <a 
            href="https://play.google.com/store/apps/details?id=app.lovable.a458feef936a4fdd9306ef7eae220648"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105"
          >
            <img 
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              className="h-14"
            />
          </a>
          <p className="text-sm text-gray-400">
            100% free for buyers • No credit card required
          </p>
        </div>
      </div>
    </section>
  );
};

export default BuyerLandingHero;
